// extracted by mini-css-extract-plugin
module.exports = {"loader":"style_loader__1GNOA","fullScreen":"style_fullScreen__6z4jj","hidden":"style_hidden__1P_z_"};